export class ToneStatus
{
    static ACCEPTED= "Accepted";
    static REJECTED= "Rejected";
    static PENDING = "Pending";
    static INACTIVE= "InActive";
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/tonestatus.ts